import { i18n } from "@/locales/setup.js"
const locale = i18n.messages[i18n.locale]

export default {
	SET_SEARCH_TERM(state, payload) {
		state.listing.searchTerm = payload
	},

	SET_FILTER_PAYLOAD(state, payload) {
		state.listing.filter.payload = payload
	},

	SET_FILTER_WHERE(state, payload) {
		state.listing.filter.where = payload
	},

	SET_PAGE(state, payload) {
		state.listing.page = payload
	},

	SET_FILTER_IS_FILTERING(state, payload) {
		state.listing.filter.isFiltering = payload
	},

	SET_HEADER(state, payload) {
		state.listing.header = payload
	},

	RESET_HEADER(state) {
		state.listing.header = [
			{
				field: "name",
				label: locale.name,
				isSorting: false,
				direction: "desc"
			},
			{
				field: "email",
				label: locale.email,
				isSorting: false,
				direction: "desc"
			},
			{
				field: "dateOfBirth",
				label: locale.date_of_birth,
				isSorting: false,
				direction: "desc"
			},
			{
				field: "createdAt",
				label: locale.created,
				isSorting: false,
				direction: "desc"
			},
			{
				field: "actions",
				label: locale.actions,
				sortable: false
			}
		]
	},

	SET_SORTING(state, payload) {
		state.listing.sorting.fieldName = payload.fieldName
		state.listing.sorting.type = payload.type
	},

	RESET_SORTING(state) {
		state.listing.sorting.fieldName = "createdAt"
		state.listing.sorting.type = "desc"
	},

	SET_TAB(state, payload) {
		state.listing.tab = payload
	}
}
